<img nz-image [width]="config.width" [height]="config.height" [nzSrc]="config.value" [nzFallback]="fallback" alt="" />
